var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"transliterate-parent"},[_c('span',{staticClass:"tool-title"},[_vm._v("Transliterate from Central Asian Cyrillic\n")]),_c('TransliterationBox',{attrs:{"transliterate":_vm.transliterateData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }